import React from "react"
import styled, { css } from "styled-components"
import { useFields } from "./App"

// @ts-ignore
const Item = styled.div<{ isActive: boolean }>`
    background: #e5e5e5;
    color: #000;
    padding: 10px 15px;
    padding-left: 30px;
    display: flex;
    align-items: center;
    margin-left: -2.5px;
    padding-left: 25px;
    user-select: none;

    clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%, 5% 50%);

    &:first-child {
        clip-path: polygon(95% 0, 100% 50%, 95% 100%, 0 100%, 0 0);
        margin-left: 0px;
        padding-left: 15px;
    }

    .nr {
        width: 30px;
        height: 30px;
        border: 2px solid #000;
        border-radius: 100%;
        text-align: center;
        margin-right: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
        font-weight: 700;
        flex: none;

        width: 30px;
        height: 30px;
        font-size: 16px;

        span {
            position: relative;
            top: 1px;
        }
    }

    ${(props) =>
        props.isActive &&
        css`
            background: #000000;
            color: #fff;
            cursor: pointer;

            .nr {
                border: 2px solid #fff;
            }
        `}
`

const Progress = React.forwardRef<HTMLDivElement, null>((props, ref) => {
    const fields = useFields()

    function handleStepClick(step: number) {
        if (fields.isComplete) {
            return
        }

        if (fields.step > step) {
            fields.setStep(step)
        }
    }

    return (
        <div
            ref={ref}
            className="xl:w-3/4 w-full sm:grid hidden lg:grid-cols-4 grid-cols-2 gap-y-3 sm:text-base text-sm"
        >
            <Item
                onClick={() => handleStepClick(1)}
                isActive={fields.step >= 1}
            >
                <span className="nr">
                    <span>1</span>
                </span>
                werkzaamheden
            </Item>
            <Item
                onClick={() => handleStepClick(2)}
                isActive={fields.step >= 2}
            >
                <span className="nr">
                    <span>2</span>
                </span>
                voorkeur datum
            </Item>
            <Item
                onClick={() => handleStepClick(3)}
                isActive={fields.step >= 3}
            >
                <span className="nr">
                    <span>3</span>
                </span>
                gegevens
            </Item>

            <Item
                onClick={() => handleStepClick(4)}
                isActive={fields.step >= 4}
            >
                <span className="nr">
                    <span>4</span>
                </span>
                bevestiging
            </Item>
        </div>
    )
})

export default Progress
